import { formatRelativeTime } from '../qCockpit/components/SharedFrames';
import { normalizeClientAlias } from '../strategyDesk/clientAlias';

/**
 * Derive operator-facing alerts from fleet instances and open positions.
 * Levels: error (underwater book), warn (stale / halted).
 */
export function deriveTodayAlerts(instances = [], positions = []) {
    const alerts = [];
    const instanceByKey = new Map(
        instances.map((instance) => [
            `${instance.strategyId}:${instance.clientId}`,
            instance,
        ])
    );

    instances.forEach((instance) => {
        const label = instance.strategyLabel || instance.strategyId;
        const client = normalizeClientAlias(instance.clientAlias, instance.clientId);

        if (instance.isHalted) {
            alerts.push({
                id: `halted:${instance.instanceId}`,
                level: 'warn',
                text: `${label} · ${client} — strategy halted`,
            });
        }

        if (instance.isStale) {
            const age = instance.lastHeartbeatAt
                ? formatRelativeTime(instance.lastHeartbeatAt)
                : 'no heartbeat';
            alerts.push({
                id: `stale:${instance.instanceId}`,
                level: 'warn',
                text: `${label} · ${client} — telemetry stale (${age})`,
            });
        }
    });

    positions
        .filter((position) => position.status === 'open' && (position.netPnl ?? 0) < 0)
        .forEach((position) => {
            const instance = instanceByKey.get(`${position.strategyId}:${position.clientId}`);
            const label = instance?.strategyLabel || position.strategyId;
            const client = normalizeClientAlias(instance?.clientAlias, position.clientId);
            const symbol = position.symbol || 'position';

            alerts.push({
                id: `underwater:${position.positionId}`,
                level: 'error',
                text: `${label} · ${client} — open position underwater (${symbol})`,
            });
        });

    const levelOrder = { error: 0, warn: 1, info: 2 };
    return alerts.sort((a, b) => (levelOrder[a.level] ?? 9) - (levelOrder[b.level] ?? 9));
}

export function countActionableAlerts(alerts = []) {
    return alerts.filter((alert) => alert.level !== 'info').length;
}
